import React from "react";
import * as RB from "react-bootstrap";
import { DocumentText1 } from "iconsax-react";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";

function QuotationFile({
  quotation = [],
  setQuotation,
  editQuotation = [],
  setEditQuotation,
  isquotation,
  isEdit,
}) {
  /* ================= FILE UPLOAD ================= */
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files).map((file) => ({
      file,
      isDeleted: false,
      source: "local",
    }));

    setQuotation((prev) => [...prev, ...files]);
    e.target.value = "";
  };

  /* ================= DELETE HANDLER ================= */
  const handleRemoveQuotationFile = (file, index) => {
    // 🔹 API file
    if (file.source === "api") {
      Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this data!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Mark deleted in UI
          setEditQuotation((prev) =>
            prev.map((f) => (f.id === file.id ? { ...f, isDeleted: true } : f)),
          );

          // API delete
          utils
            .callAPI("get", `meeting/quatation-delete?id=${file.id}`, "")
            .catch(() => {});
        }
      });
    }

    // 🔹 Local file
    else {
      setQuotation((prev) =>
        prev.map((f, i) => (i === index ? { ...f, isDeleted: true } : f)),
      );
    }
  };

  const handleDownload = async (item) => {
  const fileName = item.quatation_file;
  const fileUrl = item.attachPath;

  try {
    const response = await fetch(fileUrl, {
      method: "GET",
      headers: {}, 
    });

    if (!response.ok) throw new Error("File fetch failed");

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName; 
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);

  } catch (error) {
    console.warn("CORS or Network error, opening in new tab instead:", error);
    
    window.open(fileUrl, "_blank");
  }
};

  const renderPreview = (item, isOld) => {
    const name = isOld ? item.quatation_file : item.file.name;
    const src = isOld ? item.attachPath : URL.createObjectURL(item.file);
    const ext = name.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png"].includes(ext);

    if (isImage) {
      return (
        <img
          src={src}
          alt={name}
          onClick={() => window.open(src, "_blank")}
          style={{ cursor: "pointer", maxHeight: "100%", maxWidth: "100%" }}
        />
      );
    }

    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ height: "100%", cursor: "pointer" }}
        onClick={() => window.open(src, "_blank")}
      >
        <DocumentText1 size={40} />
        <small className="mt-1">{ext.toUpperCase()}</small>
      </div>
    );
  };

  /* ================= FILTERED LISTS ================= */
  const apiFiles = isEdit ? editQuotation.filter((f) => !f.isDeleted) : [];

  const localFiles = quotation.filter((f) => !f.isDeleted);

  /* ================= JSX ================= */
  return (
    <>
      <RB.Accordion defaultActiveKey="0" className="mb-3">
        <RB.Accordion.Item eventKey="0">
          <RB.Accordion.Header>Quotation Files</RB.Accordion.Header>
          <RB.AccordionBody>
            {!isquotation && (
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.Form.Control
                    type="file"
                    multiple
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    onChange={handleFileChange}
                  />
                </div>
              </RB.Col>
            )}

            {/* <RB.Col md={12}>
        <div className="mb-3">
          <label className="form-label">Quotation Files</label>
          <RB.Form.Control
            type="file"
            multiple
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
            onChange={handleFileChange}
            disabled={isquotation}
          />
        </div>
      </RB.Col> */}

            <RB.Row className="mt-3 g-3">
              {isEdit &&
                apiFiles.map((item) => (
                  <RB.Col key={`api-${item.id}`} className="col-md-6 col-lg-3">
                    <div className="card">
                      <div className="position-relative">
                        <div
                          className="product-image-upload d-flex align-items-center justify-content-center"
                          style={{ height: "180px" }}
                        >
                          {renderPreview(item, true)}
                        </div>

                        <div className="d-flex justify-content-center gap-2 p-2">
                          <RB.Button
                            variant="primary"
                            size="sm"
                            className="btn-circle"
                            title="Download"
                            onClick={() => handleDownload(item)}
                          >
                            <i className="material-icons-outlined">
                              file_download
                            </i>
                          </RB.Button>

                          {!isquotation && (
                            <RB.Button
                              variant="danger"
                              size="sm"
                              className="btn-circle"
                              title="Delete"
                              onClick={() =>
                                handleRemoveQuotationFile(
                                  item.isOld
                                    ? { ...item, source: "api" }
                                    : { ...item, source: "local" },
                                  item.localIndex,
                                )
                              }
                            >
                              <i
                                className="material-icons-outlined"
                                style={{ fontSize: "18px" }}
                              >
                                delete
                              </i>
                            </RB.Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </RB.Col>
                ))}

              {localFiles.map((item, index) => (
                <RB.Col key={`local-${index}`} className="col-md-6 col-lg-3">
                  <div className="card">
                    <div className="position-relative">
                      <div
                        className="product-image-upload d-flex align-items-center justify-content-center"
                        style={{ height: "180px" }}
                      >
                        {renderPreview(item, false)}
                      </div>

                      {!isquotation && (
                        <RB.Button
                          variant="danger"
                          className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                          onClick={() =>
                            handleRemoveQuotationFile(
                              { ...item, source: "local" },
                              index,
                            )
                          }
                        >
                          <i className="material-icons-outlined">delete</i>
                        </RB.Button>
                      )}
                    </div>
                  </div>
                </RB.Col>
              ))}
              {apiFiles.length === 0 && localFiles.length === 0 && (
                <RB.Col md={12}>
                  <div className="border border-dashed rounded p-4 text-center text-muted">
                    <DocumentText1 size={36} className="mb-2 opacity-50" />

                    <div className="fw-semibold">
                      {isquotation
                        ? "No quotation files are available."
                        : "No quotation files uploaded yet."}
                    </div>

                    {/* {!isquotation && (
                      <small className="d-block mt-1">
                        Upload JPG, PNG, PDF or Word documents.
                      </small>
                    )} */}
                  </div>
                </RB.Col>
              )}
            </RB.Row>
          </RB.AccordionBody>
        </RB.Accordion.Item>
      </RB.Accordion>
    </>
  );
}

export default QuotationFile;
